import axios from "axios"
import { apiDomain } from "../../store/constants"

const Auth = {
    login(data) {
        return axios({
            url: apiDomain + `login`,
            method: 'POST',
            data: data.payload
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return {status: e.response.status}
        })
    },
    logout() {
        return axios({
            url: apiDomain + `logout`,
            method: 'POST',
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return {status: e.response.status}
        })
    },
    getUser () {
        return axios({
            url: apiDomain + `api/user`,
            method: 'GET',
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    }
}

export default Auth